import btnStyle from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { gunterzBold } from '@/theme/fonts';
import { DIALOG, type InfoPaymentDialogProps } from '@/types';
import { useLingui } from '@lingui/react';
import { Box, Button, Group, Modal, Paper, Stack, Text } from '@mantine/core';
import classes from './InfoDialogViews.module.css';
export const InfoDeletePaymentModal: React.FC<InfoPaymentDialogProps> = ({
  openDialog,
  setOpenDialog
}) => {
  const {
    i18n
  } = useLingui();
  return <Modal.Root opened={openDialog === DIALOG.DEL_PAYMENT} onClose={() => setOpenDialog(null)} centered classNames={classes}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title className={gunterzBold.className} w={299} ta="center" mx="auto" pt={34}>
            {i18n._('Are you sure you want to delete this card?')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Stack gap={10}>
            <Text fz="xs" tt="uppercase" c="var(--text-dark)" ta="center" fw={700}>
              {i18n._('This card will be deleted')}
            </Text>

            <Paper radius={5} p={16} bg="linear-gradient(90deg, #303942 0%, #464F59 100%)">
              <Group gap={12}>
                <Icons className="icon-pr-line-card" fontSize={32} />
                <Box c="var(--text-dark)">
                  <Text fz="xs" tt="uppercase" fw={700}>
                    {i18n._('Credit card')}
                  </Text>
                  <Text fz="xs">{i18n._('Visa ending in 3456')}</Text>
                </Box>
              </Group>
            </Paper>
          </Stack>

          <Group mt={32} gap={10} justify="center">
            <Button fz={13} w={135} h={46} classNames={{
            root: btnStyle.button_style_2
          }} onClick={() => setOpenDialog(null)}>
              {i18n._('Cancel')}
            </Button>
            <Button fz={13} w={135} h={46} classNames={{
            root: btnStyle.root
          }} onClick={() => setOpenDialog(null)}>
              {i18n._('Delete')}
            </Button>
          </Group>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>;
};